export default "/images/3fc57131e45d1297a21d3495b2bea6cd.avif";